import { graphqlPost } from "api/graphqlClient";
import { isRequestCancelled } from "api/utils";
import NotificationService from "components/Notification/Notification.service";
import RestErrorNotification from "components/Notification/RestErrorNotification";
import { call, cancel, fork, join, put, takeEvery } from "redux-saga/effects";
import { actions as dataStoreActions } from "utils/DataStore/DataStore.reducer";

const inFlightByKey = {};

export function* fetchData({ promise, key, params, emptyListOnError, signal }) {
    try {
        const response = yield graphqlPost(params, { signal });
        yield put({
            type: dataStoreActions.STORE_DATA,
            key,
            data: response?.data,
        });
        if (promise) {
            yield call(promise.resolve, response?.data);
        }
    } catch (error) {
        if (isRequestCancelled(error)) {
            if (promise) {
                yield call(promise.resolve, undefined);
            }
            return;
        }
        if (key === "isNameExist" && error?.response?.status === 404) {
            yield put({
                type: dataStoreActions.STORE_DATA,
                key,
                data: null,
            });
        } else {
            if (emptyListOnError) {
                yield put({
                    type: dataStoreActions.STORE_DATA,
                    key,
                    data: null,
                });
            }
            NotificationService.error(<RestErrorNotification error={error} />);
        }
        if (promise) {
            yield call(promise.reject, error?.response?.data || error);
        }
    }
}

function* handleStartFetchData(action) {
    const { key } = action;
    if (inFlightByKey[key]) {
        yield cancel(inFlightByKey[key]);
    }
    const task = yield fork(fetchData, action);
    inFlightByKey[key] = task;
    try {
        yield join(task);
    } finally {
        if (inFlightByKey[key] === task) {
            delete inFlightByKey[key];
        }
    }
}

export default [takeEvery(dataStoreActions.START_FETCH_DATA, handleStartFetchData)];
